// extracted by mini-css-extract-plugin
export default {"modal":"DepartmentManagerModal-module__modal__RtNuG","content":"DepartmentManagerModal-module__content__JdmTT"};